import { Box, styled, TextV2 } from '@withjoy/joykit';
import React from 'react';

const CardWrapper = styled(Box)<{ selected?: boolean }>`
  padding: 1rem;
  background-color: ${props => (props.selected ? `rgb(213, 216, 216)` : `rgb(235, 235, 235)`)};

  border-radius: 1rem;
  height: 250px;
  width: 250px;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

type CardProps = {
  header: string;
  text: string;
  onClick?: () => void;
  selected?: boolean;
};

const Card = (props: CardProps) => {
  const { header, text, onClick, selected } = props;

  return (
    <CardWrapper onClick={onClick} selected={selected}>
      <TextV2 typographyVariant={['hed1', 'hed2']}>{header}</TextV2>
      <TextV2 typographyVariant={['label1', 'label2']}>{text}</TextV2>
    </CardWrapper>
  );
};

export default Card;
